import type { IWrapper } from './WrapperBlock.h'

import { WrapperBlockSC } from './WrapperBlock.styled'

export const WrapperBlock = (props: IWrapper) => {
  return <WrapperBlockSC {...props} />
}
